module.exports = __webpack_public_path__ + "img/chat_widget_launcher_text.262e1f37.png";